import React from 'react'
import { Box, Skeleton, Stack, Typography, useTheme } from '@mui/material'
import { styled } from '@mui/system'

const StyledWidgetInformations = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: '24px',
  display: 'flex',
}))

const InfoLine = ({
  icon,
  title,
  value,
  isBold = false,
  isClickable = false,
  onClick,
}) => {
  const theme = useTheme()

  const handleClick = () => {
    if (isClickable && onClick) {
      onClick(title)
    }
  }

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      onClick={handleClick}
      sx={{
        cursor: isClickable ? 'pointer' : 'default',
        py: 0.2,
        px: 0.5,
        borderRadius: theme.spacing(0.5),
        '&:hover': {
          backgroundColor: isClickable
            ? theme.palette.grey[100]
            : 'transparent',
        },
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        {icon && (
          <Box sx={{ color: theme.palette.primary.main }}>
            <i className={icon} />
          </Box>
        )}
        <Typography fontSize={14}>{title}</Typography>
      </Stack>
      <Box
        sx={{
          flexGrow: 1,
          height: 1,
          borderBottom: `1px solid ${theme.palette.grey[100]}`,
          mx: 1,
        }}
          />
          <Typography fontWeight={isBold ? 500 : 400} fontSize={14}>
            {value}
          </Typography>
        </Stack>
      )
    }

const WidgetInformations = ({
  label,
  labelIcon,
  lines,
  loading = false,
  hasLabel = true,
  onLineClick,
  widgetTitle,
}) => {
  const theme = useTheme()

  return (
    <StyledWidgetInformations>
      {hasLabel && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            width: '10%',
            borderRight: `1px solid ${theme.palette.grey[200]}`,
            padding: `${theme.spacing(2)} 0`,
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            sx={{
              writingMode: 'vertical-rl',
              textOrientation: 'mixed',
              display: 'flex',
              gap: '10px',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {labelIcon && (
              <Box
                sx={{
                  color: theme.palette.primary.main,
                  marginLeft: '8px',
                  fontSize: '14px',
                }}
              >
                <i className={labelIcon} />
              </Box>
            )}
            <Typography
              variant="subtitle1"
              color={theme.palette.primary.main}
              sx={{
                transform: 'rotate(180deg)',
                marginLeft: '0 !important',
                fontSize: '14px',
              }}
            >
              {label}
            </Typography>
          </Stack>
        </Box>
      )}
      <Box sx={{ flexGrow: 1, padding: `10px ${theme.spacing(2)}`, margin: 'auto 0' }}>
        {widgetTitle && (
          <Typography
            variant="subtitle2"
            sx={{
              textTransform: 'uppercase',
              fontSize: '12px',
              fontWeight: 500,
              marginBottom: theme.spacing(1),
            }}
          >
            {widgetTitle}
          </Typography>
        )}
        <Stack spacing={1}>
          {loading
            ? lines.map((_, index) => <Skeleton key={index} height={24} />)
            : lines.map((line, index) => (
              <InfoLine
                key={index}
                {...line}
                onClick={() => onLineClick && onLineClick(line)}
                isClickable={line.isClickable}
              />
            ))}
        </Stack>
      </Box>
    </StyledWidgetInformations>
  )
}

export default WidgetInformations
